<template>
  <div class="smy__card-full-box">
      <div class="timeLine" style="padding:20px 20px;line-height:20px;">
        <Timeline>
         <TimelineItem
          v-for="timeList in phoneFollowDetail"
          :key="timeList.id"
          :value="timeList.id"
         >
         <span style="float:right;">{{timeList.createtime}}</span>
             <p class="time">
                {{timeList.staff_user_name+'【主叫用户】'}}
             </p>
             <p class="time">
                {{timeList.authed_user_name+'【被叫用户】'}}
             </p>
             <p class="content">
                                        跟进记录跟进记录跟进记录跟进记录                        
             </p>
         </TimelineItem>
       </Timeline>
      </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
  },
  data () {
    return {
      dataOne: 0,
      phoneFollowDetail: [],
      pageIndex: 0,
      pageSize: 10,
      count: '',
      epId: ''
    }
  },
  computed: {
    ...mapState('followCustom', [
      'id'
    ])
  },
  methods: {
  },
  created () {
    //  智能电话拨打记录
    this.$http.get('/enterprise/calllog/list', {
      params: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        epId: this.id
      }
    }).then(res => {
      this.phoneFollowDetail = res.data
    })
//  智能电话拨打记录数量
    this.$http.get('/enterprise/calllog/count', {
      params: {
        epId: this.id
      }
    }).then(res => {
      this.count = res.data
    })
  }
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/customManage/followCustomList/cusFollowDetail/FollowDetailRightTwo.vue